import { InlineMarkdown } from '@tlx/astro-shared';

export function ErrorMessage({ errorMessage, showError }: { errorMessage: string; showError: boolean }) {
    if (!showError) {
        return null;
    }

    return (
        <span className="atl-text-red-100">
            <InlineMarkdown>{errorMessage}</InlineMarkdown>
        </span>
    );
}
